import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '../app-config.service.service';
import { Observable } from 'rxjs';
import { data } from 'jquery';

@Injectable({
  providedIn: 'root'
})
export class ContactService {
  private uri = ``;
  private apiroute = "";

  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService,
  ) {
    this.uri = this.appConfigService.apiBaseUrl;
    this.apiroute = '/FlexIntegration';
  }

  Get_POAllWithSearch(number,statusid,vendorid,date){
    return this.http.post<any>(this.uri + this.apiroute, {
      method: "Get_POAllWithSearch",
      number: number,
      statusid: statusid,
      vendorid: vendorid,
      date: date,
    })
  }

  Get_PurchaseOrderReport(id){
    return this.http.post<any>(this.uri + this.apiroute, {
      method: "Get_PurchaseOrderReport",
      poid: id
    })
  }

  SP_API_Flex_Get_ContactsCE(): Observable<any> {
    return this.http.post<any>(this.uri + this.apiroute, {
      method: "Get_ContactsCE"
    })
  }
  SP_API_Flex_Estimates_Get_Contacts(page): Observable<any> {
    return this.http.post<any>(this.uri + this.apiroute, {
      method: "Estimates_Get_Contacts",
      pageindex: page.pageindex,
      pagesize: page.pagesize
    })
  }


  SP_API_Flex_Delete_Contacts(id): Observable<any> {
    return this.http.post<any>(this.uri + this.apiroute, {
      method: "Delete_Contacts",
      id: id
    })
  }
  Get_VendorsByIDCE(id): Observable<any> {
    return this.http.post<any>(this.uri + this.apiroute, {
      method: "Get_VendorsByIDCE ",
      id: id
    })
  }

  Get_VendorsAll(): Observable<any> {
    return this.http.post<any>(this.uri + this.apiroute, {
      method: "Get_VendorsAll",
    })

  }
  Get_VendorsAllByName(name): Observable<any> {
    return this.http.post<any>(this.uri + this.apiroute, {
      method: "Get_VendorsAllByName",
      name: name
    })

  }
  Get_PartsALl(name): Observable<any> {
    return this.http.post<any>(this.uri + this.apiroute, {
      method: "Get_PartsALlCE",
      name: name
    })
  }

  Get_PartsALlCEPaged(index, size): Observable<any> {
    let obj = {
      method: "Get_PartsALlCEPaged",
      pageindex: index,
      pagesize: size
    }
    console.log(obj);
    return this.http.post<any>(this.uri + this.apiroute, obj)
  }

  PartsOnDemand(name): Observable<any> {
    return this.http.post<any>(this.uri + this.apiroute, {
      method: "Get_PartsALlCETop",
      name: name
    })
  }

  GetPurchaseOrdersInfo(id): Observable<any> {
    return this.http.post<any>(this.uri + this.apiroute, {
      method: "GetPurchaseOrdersInfo",
      poid: id
    })

  }

  GetPurchaseOrdersDetails(id): Observable<any> {
    return this.http.post<any>(this.uri + this.apiroute, {
      method: "GetPurchaseOrdersDetailsCE ",
      poid: id
    })

  }

  Get_ReconcileAll(date): Observable<any> {
    return this.http.post<any>(this.uri + this.apiroute, {
      method: "Get_ReconcileAll",
      tsdate: date
    })
  }
  Get_PartLocation(): Observable<any> {
    return this.http.post<any>(this.uri + this.apiroute, {
      method: "Get_PartLocation",
    })

  }

  Get_ReconcileAllSearch(form){
    return this.http.post<any>(this.uri + this.apiroute, form);
  }

  get(model) {
    return this.http.post<any>(this.uri + '/Contacts', model);
  }

  getUrl() {
    return this.uri + '/Contacts';
  }

  GetCustomer(id = 0) {
    return this.http.post<any>(this.uri + '/Customer', { Id: id });
  }

  GetContactByName(name) {

    return this.http.post<any>(this.uri + '/Contacts/Get_AllContactsByName', { name: name });
  }

  Get_AllContacts(name){
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: "Get_ContactsByName", name: name});
  }

  Get_ContactsAll2(){
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: "Get_ContactsAll"});
  }

  GetContactByName2(value) {
    return this.http.post(this.uri + '/FlexIntegration', { "method": "Get_ContactsCE ", "name": value })
  }

  GetContactById(id) {
    return this.http.post<any>(this.uri + '/Contacts/GetContactByID', { Id: id });
  }

  GetContactCountries() {
    return this.http.post<any>(this.uri + '/Contacts/GetContactCountries', {});
  }

  SaveContact(contact) {
    return this.http.post<any>(this.uri + '/Contacts/InsertContact/', contact);
  }

  UpdateContact(contact) {
    return this.http.post<any>(this.uri + '/Contacts/UpdateContact/', contact);
  }

  DeleteContact(contacid) {
    return this.http.post<any>(this.uri + '/Contacts/DeleteContact/', { id: contacid });
  }

  GetContactsToExport() {
    return this.http.post<any>(this.uri + '/Contacts/Get_ContactsExport/', {});
  }

  Get_MaterialRequestAllCE(): Observable<any> {
    return this.http.post<any>(this.uri + this.apiroute, {
      method: "Get_MaterialRequestAllCE",
    })

  }
  Get_POAll(date): Observable<any> {
    return this.http.post<any>(this.uri + this.apiroute, {
      method: "Get_POAll",
      tsdate: date
    })

  }

  Get_POAll2(date): Observable<any> {
    return this.http.post<any>(this.uri + this.apiroute, {
      method: "Get_PO_SubAll",
      tsdate: date
    })

  }

  GetOpenRecieved(id){
    return this.http.post<any>(this.uri + '/FlexIntegration',{method: 'Get_OpenReceivedforPo', poid: id});
  }

  GetCustomerCountry(): Observable<any> {
    return this.http.post<any>(this.uri + this.apiroute, {
      method: "GetCustomerCountryCE",
    })
  }
  Get_ContactsAll(): Observable<any> {
    return this.http.post<any>(this.uri + this.apiroute, {
      method: "Get_ContactsAll",
    })
  }
  Get_ProjectList(): Observable<any> {
    return this.http.post<any>(this.uri + '/FlexIntegration',
      {
        method: 'Get_SalesProjectList',
      }
    );
  }
  Get_PO_StatusCE(): Observable<any> {
    return this.http.post<any>(this.uri + '/FlexIntegration',
      {
        method: 'Get_PO_StatusCE',
      }
    );
  }
  Get_PurchaseOrderShiptoddress(): Observable<any> {
    return this.http.post<any>(this.uri + '/FlexIntegration',
      {
        method: 'Get_PurchaseOrderShiptoddress',
      }
    );
  }
  Get_PurchaseOrderShiptoddressByID(id): Observable<any> {
    return this.http.post<any>(this.uri + '/FlexIntegration',
      {
        method: 'Get_PurchaseOrderShiptoddress',
        projectid: id
      }
    );
  }
  Get_POItem_Status(): Observable<any> {
    return this.http.post<any>(this.uri + '/FlexIntegration',
      {
        method: 'Get_POItem_Status',
      }
    );
  }
  Delete_POitem(id): Observable<any> {
    return this.http.post<any>(this.uri + '/FlexIntegration',
      {
        method: 'Delete_POitem',
        poid: id
      }
    );
  }
  GetPurchaseOrdersDetailsByPOIItemID(id): Observable<any> {
    return this.http.post<any>(this.uri + '/FlexIntegration',
      {
        method: 'GetPurchaseOrdersDetailsByIdCE',
        poitemid: id
      }
    );
  }
  GetPurchaseOrdersDetailsByIdCERec(id): Observable<any> {
    return this.http.post<any>(this.uri + '/FlexIntegration',
      {
        method: 'GetPurchaseOrdersDetailsByIdCERec',
        poitemid: id
      }
    );
  }
  Insert_PurchaseOrdersDetail(data): Observable<any> {
    let obj = {
      method: 'Insert_PurchaseOrdersDetail',
      poitemid: data.poitemid,
      poid: data.poid,
      partid: data.partid,
      projectid: data.projectid,
      qty: data.qty,
      typeid: data.type,
      statusid: data.status,
      note: data.notes,
      unitcost: data.unitcost,
      totalcost: data.totalcost
    }
    console.log(obj)
    return this.http.post<any>(this.uri + '/FlexIntegration',obj);
  }


  Insert_PurchaseOrdersInfo(data): Observable<any> {
    console.log({
      method: "Insert_PurchaseOrdersInfo",
      poid: data.poid,
      num: data.num,
      vendorid: data.vendorid,
      statusid: data.statusid,
      notes: data.notes,
      shiptoname: data.shiptoname,
      shiptoaddress: data.shiptoaddress,
      shiptocity: data.shiptocity,
      shiptostate: data.shiptostate,
      shiptocountry: data.shiptocountry
    })
    return this.http.post<any>(this.uri + this.apiroute, {
      method: "Insert_PurchaseOrdersInfo",
      poid: data.poid,
      num: data.num,
      vendorid: data.vendorid,
      statusid: data.statusid,
      notes: data.notes,
      shiptoname: data.shiptoname,
      shiptoaddress: data.shiptoaddress,
      shiptocity: data.shiptocity,
      shiptostate: data.shiptostate,
      shiptocountry: data.shiptocountry
    })
  }

  Update_Vendors(data): Observable<any> {
    return this.http.post<any>(this.uri + this.apiroute, {
      method: "InsertUpdate_VendorsCE",
      id: data.id,
      vendorid: data.vendorid,
      accountid: data.accountid,
      statusid: data.statusid,
      name: data.name,
      dateentered: data.dateentered,
      creditlimit: data.creditlimit,
      activeflag: data.activeflag,
      clientid: data.clientid,
      mainphone: data.mainphone,
      mainfax: data.mainfax,
      mobile: data.mobile,
      mainemail: data.mainemail,
      ccemail: data.ccemail,
      webaddress: data.webaddress,
      notes: data.notes,
      maincontactid: data.maincontactid,
      altcontactid: data.altcontactid,
      currencyid: data.currencyid,
      addressflag: data.addressflag,
      billfromname: data.billfromname,
      billfromaddress: data.billfromaddress,
      billfromaddressline2: data.billfromaddressline2,
      billfromcity: data.billfromcity,
      billfromstate: data.billfromstate,
      billfromzip: data.billfromzip,
      billfromcountry: data.billfromcountry,
      shipfromname: data.shipfromname,
      shipfromaddress: data.shipfromaddress,
      shipfromaddressline2: data.shipfromaddressline2,
      shipfromcity: data.shipfromcity,
      shipfromstate: data.shipfromstate,
      shipfromzip: data.shipfromzip,
      shipfromcountry: data.shipfromcountry,
      issubcontractor: data.issubcontractor
    })
  }
  InsertUpdate_VendorsCE(data): Observable<any> {
    return this.http.post<any>(this.uri + this.apiroute, {
      method: "InsertUpdate_VendorsCE",
      id: 0,
      vendorid: 0,
      accountid: data.accountid,
      statusid: data.statusid,
      name: data.name,
      dateentered: data.dateentered,
      creditlimit: data.creditlimit,
      activeflag: data.activeflag,
      clientid: data.clientid,
      mainphone: data.mainphone,
      mainfax: data.mainfax,
      mobile: data.mobile,
      mainemail: data.mainemail,
      ccemail: data.ccemail,
      webaddress: data.webaddress,
      notes: data.notes,
      maincontactid: data.maincontactid,
      altcontactid: data.altcontactid,
      currencyid: data.currencyid,
      addressflag: data.addressflag,
      billfromname: data.billfromname,
      billfromaddress: data.billfromaddress,
      billfromaddressline2: data.billfromaddressline2,
      billfromcity: data.billfromcity,
      billfromstate: data.billfromstate,
      billfromzip: data.billfromzip,
      billfromcountry: data.billfromcountry,
      shipfromname: data.shipfromname,
      shipfromaddress: data.shipfromaddress,
      shipfromaddressline2: data.shipfromaddressline2,
      shipfromcity: data.shipfromcity,
      shipfromstate: data.shipfromstate,
      shipfromzip: data.shipfromzip,
      shipfromcountry: data.shipfromcountry
    })
  }
  Get_AccPartsServiceDetail(filter): Observable<any> {
    return this.http.post<any>(this.uri + '/FlexIntegration', {
      method: "Get_PartsforPOALlCE",
      description:  filter
      // method: "Get_PartsALlCE",
    })
  }
  Get_VendoParts(vendorid, id ) {
    return this.http.post<any>(this.uri + '/FlexIntegration', {
      method: "Get_VendorPartSugestedValues",
      vendorid: vendorid ,
      id: id
    })
  }
  Get_ProjectPartDetailSugestedValues(idpart, vendorid): Observable<any> {
    return this.http.post<any>(this.uri + this.apiroute, {
      // method: "Get_ProjectPartDetailSugestedValues",
      method: 'Get_VendorPartSugestedValues',
      id: idpart,
      vendorid: vendorid
    })
  }
  GetAllProjects(name) {
    console.log({ method: 'Get_ProjectsForPo', projectname: name })
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_ProjectsForPo', projectname: name }); 
  }
  Get_POITEMTypeList() {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_POITEMTypeList' });
  }
  Update_PODefaultvendorcost(id) {
    return this.http.post<any>(this.uri + '/FlexIntegration', {
      method: 'Update_PODefaultvendorcost',
      poid: id
    });
  }
  Get_VendorPartSugestedValues(vendorid, parid): Observable<any> {
    return this.http.post<any>(this.uri + this.apiroute, {
      method: "Get_VendorPartSugestedValues",
      id: parid,
      vendorid: vendorid,
    })
  }
  InsertUpdate_VendorParts(data): Observable<any> {
    return this.http.post<any>(this.uri + this.apiroute, {
      method: "InsertUpdate_VendorParts",
      id: data.id,  
      partid: data.partid,
      vendorid: data.vendorid,
      partnumber: data.partnumber,
      default: data.default,
      lastcost: data.lastcost,
      listprice: data.listprice,
    })
  }
  InsertUpdate_PurchaseOrderReceiveItems(data, refno, datebilled, location, id){
    let obj = {
      method: "InsertUpdate_PurchaseOrderReceiveItems",
      refno: refno,
      datebilled: datebilled,
      qty: data.QTYU,
      // qtyfulfilled: data.QTYFULFILLED,
      locationgroupid: location,
      poid: data.POID,
      poitemid: data.POitemID,
      receiptid: id,
      partid: data.PARTID, 
      // qtytofulfill: data.Qty,
      // statusid: data.StatusID,
      // typeid: data.TypeId,
    }
    console.log('saved ',obj);
    return this.http.post<any>(this.uri + '/FlexIntegration', obj)
  }

  NotificationsPO(obj){
    return this.http.post(this.uri + '/Notifications/NotificationPO', obj )
  }

  Update_PostReceiptItems(id){
    return this.http.post<any>(this.uri + '/FlexIntegration', {method: 'Update_PostReceiptItems', reciptid: id})
  }

  Get_VendorsMasterByIDCE(id): Observable<any> {
    return this.http.post<any>(this.uri + this.apiroute, {
      method: "Get_MasterVendorsByID",
      id: id
    })
  }

  Get_VendorsAllMaster(): Observable<any> {
    return this.http.post<any>(this.uri + this.apiroute, {
      method: "Get_VendorsMaster",
    })
  }

  PartsMasterOnDemand(name): Observable<any> {
    return this.http.post<any>(this.uri + this.apiroute, {
      method: "Get_PartsMasterALlCETop",
      name: name
    })
  }

  Get_VendorsAllActive(): Observable<any> {
    return this.http.post<any>(this.uri + this.apiroute, {
      method: "Get_VendorsAllActive",
    })
  }

}
